export default __webpack_public_path__ + "static/media/photography.a2e86ba9.png";